import { getCookie } from "cookies-next";
import PropTypes from "prop-types";
import { TiDelete } from "react-icons/ti";
import { useDispatch } from "react-redux";
import { updatedTeamLeads } from "store/user/userSlice";
import { getUsers } from "store/user/userThunk";
import { deleteUsers } from "store/user/userThunk";

export default function DeleteTeamLeadModal({ toggleModal, teamLeadData }) {
    const dispatch = useDispatch();
    const handleDeleteClick = () => {
        const user = getCookie('user');
        const userID = teamLeadData.Id
        dispatch(deleteUsers(
            {
                userID,
                onSuccess: () => {
                    dispatch(updatedTeamLeads({ userID }))
                    if (user == 'admin'){
                        dispatch(getUsers())
                    }
                }
            }))
        toggleModal()
    }
    return (
        <div className="modal_overlay">
            <div className="w-[500px] bg-white p-6 rounded-lg">
                <div className="flex justify-end">
                    <button className="modal_close_button" onClick={toggleModal}>
                        <TiDelete size={24} className="text-red-400 hover:text-red-600" />
                    </button>
                </div>
                <div className="p-6">
                    <h2 className="text-xl font-bold text-gray-800">Delete Team Lead</h2>
                    <p className="mt-4 text-gray-600">
                        Are you sure you want to delete {`${teamLeadData.first_name} ${teamLeadData.last_name} `}? This action cannot be undone.
                    </p>
                </div>
                <div className="modal_actions">
                    <button
                        type="button"
                        className="button_cancel"
                        onClick={toggleModal}
                    >
                        Cancel
                    </button>
                    <button onClick={handleDeleteClick} type="button" className="button_submit" >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

DeleteTeamLeadModal.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    teamLeadName: PropTypes.string,
};

DeleteTeamLeadModal.defaultProps = {
    teamLeadName: "this teamLead",
};
